// extracted by mini-css-extract-plugin
export default {"projects":"projects_projects__nuCvt","topRow":"projects_topRow__7BDOe","titleRow":"projects_titleRow__SXEcL","projectRow":"projects_projectRow__RPQwT","card":"projects_card__Q49YE"};